import React from "react";
import { FiCalendar, FiMessageCircle, FiCamera, FiImage } from "react-icons/fi";

const Process = () => {
  const process = [
    {
      number: "01",
      title: "Book Your Session",
      desc: "Choose your event type and preferred date. Share your vision with us.",
      icon: <FiCalendar size={32} />,
    },
    {
      number: "02",
      title: "Planning & Consultation",
      desc: "Discuss locations, style, mood, and every detail that matters to you.",
      icon: <FiMessageCircle size={32} />,
    },
    {
      number: "03",
      title: "Photography Day",
      desc: "We capture every memorable moment with our expert eye and equipment.",
      icon: <FiCamera size={32} />,
    },
    {
      number: "04",
      title: "Delivery & Beyond",
      desc: "Receive beautifully edited photos, videos, and albums to treasure forever.",
      icon: <FiImage size={32} />,
    },
  ];

  return (
    <section className="bg-white py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-20 text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-12 h-[2px] bg-gradient-to-r from-amber-400 to-transparent"></div>
            <p className="text-xs uppercase tracking-[4px] text-amber-500 font-bold">
              Our Process
            </p>
            <div className="w-12 h-[2px] bg-gradient-to-l from-amber-400 to-transparent"></div>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-4">
            How We Work
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From booking to delivery, we guide you through a seamless creative process
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {process.map((item, idx) => (
            <div
              key={item.number}
              className="group relative p-8 bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 hover:border-amber-400 transition-all duration-300 hover:shadow-xl hover:shadow-amber-400/10"
            >
              {/* Connector Line */}
              {idx < process.length - 1 && (
                <div className="hidden lg:block absolute top-1/4 -right-8 w-16 h-[2px] bg-gradient-to-r from-amber-400 to-transparent"></div>
              )}

              <div className="flex h-16 w-16 items-center justify-center border-2 border-amber-400 bg-white text-amber-500 group-hover:bg-amber-400 group-hover:text-white transition mb-8">
                {item.icon}
              </div>

              <span className="text-5xl font-black text-amber-400/20 mb-4 block">
                {item.number}
              </span>

              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {item.title}
              </h3>

              <p className="text-gray-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;